module.exports = __webpack_public_path__ + "static/media/pennant.3df25dd0.svg";